// dependencies imports ⇒
import React from "react";
import moment from "moment";
// assets and scss imports ⇒
import "./patientDetails.scss";
import FormInputWithHeader from "../../common/FormInputWithHeader";

const PatientDetails = (props) => {
  const { patientDetails, referredBy, handleReferredByChange } = props;

  // create UI ⇒
  const patientDetailsUI = () => {
    return (
      <div className="patient-details-container">
        <div className="patient-details-content name">
          Patient : {patientDetails?.patient_name}
        </div>
        {patientDetails?.formatted_uhid && (
          <div
            className="patient-details-content b-left  uhid"
            style={{
              overflowWrap: "anywhere",
              textAlign: "inherit",
            }}
          >
            {patientDetails?.formatted_uhid}
          </div>
        )}
        <div className="patient-details-content pr-1 b-left  mobileno">
          {patientDetails?.phone_no}
        </div>
        <div className="patient-details-content consultation_date b-left  ">
          {patientDetails?.appointment_date != "" &&
            patientDetails?.appointment_start_time != "" &&
            `${
              moment(patientDetails?.appointment_date).format("MMM DD, YYYY") +
              " at " +
              moment(
                patientDetails?.appointment_start_time,
                "hh:mm:ssZ"
              ).format("hh:mm A")
            }`}
        </div>
        <div className="patient-details-content referred_by b-left ">
          Referred By
          <FormInputWithHeader
            value={referredBy}
            handleOnChangeInput={handleReferredByChange}
          />
        </div>
      </div>
    );
  };
  return (
    <div className="patient-details-wraper-cont">{patientDetailsUI()}</div>
  );
};

//export
export default PatientDetails;
